var map = {
	"./android.svg": 337,
	"./female.svg": 162,
	"./ios.svg": 338,
	"./male.svg": 163
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1331;


//////////////////
// WEBPACK FOOTER
// ./src/shared/images/audience ^\.\/.*\.svg$
// module id = 1331
// module chunks = 0